import { render } from "./XIconSolidCog.vue?vue&type=template&id=8d7c78de"
import script from "./XIconSolidCog.vue?vue&type=script&lang=js"
export * from "./XIconSolidCog.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidCog.vue"]])

export default __exports__